// Stock catalog used by the customer portal. Real brand icons from
// /cloned/wp-content/uploads/stocks/. Prices are seeded but updated from
// /api/apps/funderpro-live/dashboard/summary in the real flow.

export interface Stock {
  id: string;
  symbol: string;        // AAPL, NVDA
  name: string;          // Apple Inc.
  exchange: string;      // NASDAQ
  currency: string;      // USD
  icon: string;          // /cloned/wp-content/uploads/stocks/aapl.svg
  color: string;         // brand color
  price: number;
  change: number;        // pct
  marketCap?: string;
  description: string;
  category: 'tech' | 'cloud' | 'ai' | 'finance' | 'crypto';
  collections: string[]; // collection ids this stock belongs to
}

export const STOCKS: Stock[] = [
  {
    id: 'stk-aapl', symbol: 'AAPL', name: 'Apple', exchange: 'NASDAQ US',
    currency: 'USD', icon: '/cloned/wp-content/uploads/stocks/aapl.svg', color: '#000',
    price: 278.20, change: 3.65,
    marketCap: '$4.20T', description: 'Apple Inc. designs, manufactures, and markets smartphones, personal computers, tablets, wearables, and accessories worldwide.',
    category: 'tech',
    collections: ['tech-leaders', 'ai-chips'],
  },
  {
    id: 'stk-nvda', symbol: 'NVDA', name: 'NVIDIA', exchange: 'NASDAQ US',
    currency: 'USD', icon: '/cloned/wp-content/uploads/stocks/nvda.svg', color: '#76B900',
    price: 185.41, change: 6.21,
    marketCap: '$4.50T', description: 'NVIDIA Corporation provides graphics, computing and networking solutions. The company pioneered accelerated computing to help solve complex problems.',
    category: 'ai',
    collections: ['ai-chips', 'tech-leaders'],
  },
  {
    id: 'stk-msft', symbol: 'MSFT', name: 'Microsoft', exchange: 'NASDAQ US',
    currency: 'USD', icon: '/cloned/wp-content/uploads/stocks/msft.svg', color: '#F25022',
    price: 278.12, change: -4.12,
    marketCap: '$2.10T', description: 'Microsoft Corporation develops and supports software, services, devices, and solutions worldwide.',
    category: 'cloud',
    collections: ['cloud-software', 'tech-leaders'],
  },
  {
    id: 'stk-amzn', symbol: 'AMZN', name: 'Amazon', exchange: 'NASDAQ US',
    currency: 'USD', icon: '/cloned/wp-content/uploads/stocks/amzn.svg', color: '#FF9900',
    price: 210.32, change: 5.52,
    marketCap: '$2.30T', description: 'Amazon.com, Inc. engages in the retail sale of consumer products and subscriptions through online and physical stores.',
    category: 'tech',
    collections: ['cloud-software', 'tech-leaders'],
  },
  {
    id: 'stk-googl', symbol: 'GOOGL', name: 'Alphabet', exchange: 'NASDAQ US',
    currency: 'USD', icon: '/cloned/wp-content/uploads/stocks/googl.svg', color: '#4285F4',
    price: 322.86, change: 6.21,
    marketCap: '$3.10T', description: 'Alphabet Inc. is the parent company of Google, the leading global search engine and advertising platform.',
    category: 'cloud',
    collections: ['cloud-software', 'ai-chips', 'tech-leaders'],
  },
  {
    id: 'stk-tsla', symbol: 'TSLA', name: 'Tesla', exchange: 'NASDAQ US',
    currency: 'USD', icon: '/cloned/wp-content/uploads/stocks/tsla.svg', color: '#E31937',
    price: 412.30, change: -4.18,
    marketCap: '$1.40T', description: 'Tesla, Inc. designs, manufactures, and sells electric vehicles, energy generation and storage systems.',
    category: 'tech',
    collections: ['ai-chips'],
  },
  {
    id: 'stk-eth', symbol: 'ETH', name: 'Ethereum', exchange: 'Crypto',
    currency: 'USD', icon: '/cloned/wp-content/uploads/stocks/eth.svg', color: '#627EEA',
    price: 5978.08, change: 8.08,
    marketCap: '$720B', description: 'Ethereum is a decentralized, open-source blockchain platform that enables developers to build and deploy decentralized applications.',
    category: 'crypto',
    collections: [],
  },
  {
    id: 'stk-btc', symbol: 'BTC', name: 'Bitcoin', exchange: 'Crypto',
    currency: 'USD', icon: '/cloned/wp-content/uploads/stocks/coin.svg', color: '#F7931A',
    price: 96420.50, change: 2.31,
    marketCap: '$1.90T', description: 'Bitcoin is a decentralized digital currency, without a central bank or single administrator.',
    category: 'crypto',
    collections: [],
  },
];

export const COLLECTIONS = [
  {
    id: 'tech-leaders',
    name: 'Tech Leaders',
    count: 8,
    description: 'The biggest names in technology — Apple, NVIDIA, Microsoft, Alphabet, Amazon, Meta, Tesla, and more.',
    icon: 'tech',
    gradient: 'from-[#7E9AFF]/40 to-[#7E9AFF]/0',
    accentColor: '#7E9AFF',
  },
  {
    id: 'cloud-software',
    name: 'Cloud & Software',
    count: 7,
    description: 'Cloud platforms, SaaS leaders, and enterprise software powering modern business.',
    icon: 'cloud',
    gradient: 'from-[#5856D6]/30 to-[#5856D6]/0',
    accentColor: '#5856D6',
  },
  {
    id: 'ai-chips',
    name: 'AI & Chips',
    count: 6,
    description: 'Semiconductors and AI infrastructure companies at the center of the compute revolution.',
    icon: 'chip',
    gradient: 'from-[#FF6B9A]/30 to-[#FF6B9A]/0',
    accentColor: '#FF6B9A',
  },
];

// Reward offer (Free Stock Rewards) — shown on dashboard, claimed from /portal/rewards
export const REWARD_OFFER = {
  title: 'Free Stock Rewards',
  subtitle: 'Redeem now and get $4 stock rewards. Reward stocks are credited instantly.',
  expiresIn: '1d 23h 59m 34s',
  stockValue: 4.00,
  brandIds: ['aapl', 'nvda', 'amzn'], // shown in the constellation
};
